module.exports = __webpack_public_path__ + "static/media/02_MICS-1.2-C-8 1.e792d357.svg";